import { FormControlLabel, FormGroup } from '@mui/material'
import React from 'react'
import { AccountLinkModel } from 'src/Libs/installation-rights-management/models'
import Checkbox from 'src/Libs/inputs/formik/Checkbox'
import { Installation } from 'src/Libs/installations/models/installation.model'
import { ExtensionsType } from 'src/Libs/api/types'
import { isInstallationOwner } from '../../utils'

interface Props {
  item?: AccountLinkModel
  installation: Installation
  label?: string
  name?: string
}
const ToggleWriteAccessControl: React.VFC<Props> = ({ item, installation, label, name }) => {
  const isOwner = item && isInstallationOwner(item, installation)
  const isLuoxEnergy = item?.permissionType === ExtensionsType.luoxEnergy
  const isDisabled = isOwner || isLuoxEnergy

  const inputControl = <Checkbox checked={isLuoxEnergy} disabled={isDisabled} name={name} />

  if (label) {
    return (
      <FormGroup>
        <FormControlLabel control={inputControl} label={label} />
      </FormGroup>
    )
  }

  return inputControl
}

export default ToggleWriteAccessControl
